import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { axiosBeelineRequest } from '@beef/utils';
import { Content } from "../../../../../../../dependencies/getContent/Content";
import { EStatus } from "../../../../../../../../constants";
import { poll } from "../../../../../../../../utils/fn";
import { State } from "../../../../../../../dependencies/getState/State";
import { EPaymentMethod } from "../../../../../../../dependencies/getContent/constants";
import { getBindingFromId } from "../../../../PaymentSelection/components/PaymentMethodSection/Button/logic/utils";
import { recursiveMerge } from "../../../../../../../../utils/recursiveMerge";
import { QRCodeStorage } from "../initializeQRCode/QRCode";
export var pollSbpStatus = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var _settings$fps;
    var _payId, accountNumber, _QRCodeStorage$getIns, payId, _Content$getInstance$, settings, _recursiveMerge, interval, timeout, _yield$poll, isSuccessful, status;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _payId = _ref.payId, accountNumber = _ref.accountNumber;
          _QRCodeStorage$getIns = QRCodeStorage.getInstance().getData(), payId = _QRCodeStorage$getIns.payId;
          _Content$getInstance$ = Content.getInstance().getData(), settings = _Content$getInstance$.requestSettings;
          _recursiveMerge = recursiveMerge(settings.default, (_settings$fps = settings.fps) !== null && _settings$fps !== void 0 ? _settings$fps : {}), interval = _recursiveMerge.interval, timeout = _recursiveMerge.timeout;
          _context2.next = 6;
          return poll(function () {
            return axiosBeelineRequest({
              params: {
                payId: _payId !== null && _payId !== void 0 ? _payId : payId,
                ctn: accountNumber
              },
              url: '/sbpapi/payment-status/'
            }).then( /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      return _context.abrupt("return", {
                        isSuccessful: res.requestStatus === 'Complete',
                        status: res.requestStatus
                      });
                    case 1:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function (_x2) {
                return _ref3.apply(this, arguments);
              };
            }());
          }, function (_ref4) {
            var _state$selectedPaymen;
            var _isSuccessful = _ref4.isSuccessful,
              _status = _ref4.status;
            var state = State.getInstance().getData();
            var isQuickPayment = getBindingFromId((_state$selectedPaymen = state.selectedPaymentId) !== null && _state$selectedPaymen !== void 0 ? _state$selectedPaymen : '');
            var isSBPClosed = !state.scenario || state.scenario.type !== EPaymentMethod.SBP;
            if (isSBPClosed && !isQuickPayment) return false;
            return !_isSuccessful && _status !== 'Error';
          }, interval, timeout);
        case 6:
          _yield$poll = _context2.sent;
          isSuccessful = _yield$poll.isSuccessful;
          status = _yield$poll.status;
          if (!(status === 'InProgress')) {
            _context2.next = 11;
            break;
          }
          return _context2.abrupt("return", EStatus.Processing);
        case 11:
          if (isSuccessful) {
            _context2.next = 13;
            break;
          }
          return _context2.abrupt("return", EStatus.PaymentError);
        case 13:
          return _context2.abrupt("return", EStatus.Success);
        case 14:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function pollSbpStatus(_x) {
    return _ref2.apply(this, arguments);
  };
}();